import { gql } from "@apollo/client";

export const GET_USERS = gql`
	query GetUsers($input: UsersInput!) {
		users(input: $input) {
			users {
				id
				name
				friendlyName
				email
				role
				minorRoles
				emloyee1c
				userToWarehouses {
					id
					accessType
					warehouse {
						id
						name
						city
					}
				}
				tempPassword
				passwordStatus
			}
		}
	}
`;

export const GET_USERS_FOR_SELECT = gql`
	query GetUsersForSelect($input: UsersInput!) {
		users(input: $input) {
			users {
				id
				name
				friendlyName
				email
				role
				emloyee1c
			}
		}
	}
`;

export const GET_MANAGERS = gql`
	query GetManagers($search: String!) {
		users(input: { search: $search, roles: [MANAGER] }) {
			users {
				id
				name
				friendlyName
				email
				role
				emloyee1c
			}
		}
	}
`;

export const FREE_DRIVERS = gql`
	query FreeDriver {
		freeDrivers {
			id
			name
			friendlyName
			email
			role
			emloyee1c
			userToWarehouses {
				id
				accessType
				warehouse {
					id
					name
					city
				}
			}
		}
	}
`;

export const ACTIVE_DRIVERS = gql`
	query ActiveDrivers {
		activeDrivers {
			id
			name
			friendlyName
			car {
				id
				model
				number
				coords {
					id
					trackId
					lat
					lan
				}
			}
			orders {
				id
				orderNumber
				clientName
				status
			}
		}
	}
`;

export const UPDATE_USER = gql`
	mutation UpdateUser($input: UpdateUserInput!) {
		updateUser(input: $input) {
			id
		}
	}
`;

export const DELETE_USER = gql`
	mutation DeleteUser($id: String!) {
		deleteUser(id: $id)
	}
`;

export const RESET_PASSWORD = gql`
	mutation ResetPassword($id: String!) {
		resetPassword(id: $id)
	}
`;

export const UPDATE_READ_WAREHOUSES = gql`
	mutation UpdateReadWarehouses($input: UpdateReadWarehousesInput!) {
		updateReadWarehouses(input: $input) {
			id
			userId
			accessType
			warehouseId
			createdAt
		}
	}
`;

export const UPDATE_WRITE_WAREHOUSES = gql`
	mutation UpdateWriteWarehouses($input: UpdateWriteWarehousesInput!) {
		updateWriteWarehouses(input: $input) {
			id
			userId
			accessType
			warehouseId
			createdAt
		}
	}
`;
